




import Vue from 'vue'
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component
export default class NumberInput extends Vue {
  @Prop() value?: any;
  @Prop(Number) min?: number;
  @Prop(Number) max?: number;

  isInputFocused = false;

  get viewValue() {
    if (this.isInputFocused) {
      return this.getInputElement().value;
    } else {
      return this.value;
    }
  }

  getInputElement(): HTMLInputElement {
    return this.$refs.input as HTMLInputElement;
  }

  onKeydown(ev: KeyboardEvent) {

  }

  onInput(ev: Event) {
    this.updateModel((ev.target as HTMLInputElement).value);
  }

  onFocus() {
    this.isInputFocused = true;
    this.getInputElement().select();
  }

  onBlur() {
    this.isInputFocused = false;
  }

  updateModel(newValue: any | undefined) {
    if (typeof newValue !== 'string' || newValue === '') {
      this.$emit("input", undefined);
      return;
    }

    newValue = newValue.replace(',', '.');
    const number = parseFloat(newValue);
    const modelValue = isNaN(number) ? undefined : this.restrictNewModel(number);
    this.$emit("input", modelValue);
  }

  restrictNewModel(value: number): number {
    if (typeof this.min === 'number' && value < this.min) {
      return this.min;
    }

    if (typeof this.max === 'number' && value > this.max) {
      return this.max;
    }

    return value;
  }
}
